<div class="ui-block">
  <em-spinner></em-spinner>
</div>
<div class="ui-block-backdrop"></div>
